import type { QueueItem} from '@/types/auth.types'
import {defaultApiClient} from "@/global/api/default-api";

export class TokenManager {

    private isRefreshing = false;
    private failedQueue: QueueItem[] = [];

    private processQueue(error: Error | null, token: string | null): void {
        this.failedQueue.forEach(item => {
            if (error) {
                item.reject(error);
            } else {
                item.resolve(token);
            }
        });
        this.failedQueue = [];
    }

    public async handleTokenRefresh(
        originalRequest: any,
        refreshTokenFn: () => Promise<string>,
        onRefreshError: () => void
    ): Promise<any> {
        if (this.isRefreshing) {
            return this.enqueueRequest(originalRequest);
        }

        return this.refreshToken(originalRequest, refreshTokenFn, onRefreshError);
    }

    private async enqueueRequest(originalRequest: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.failedQueue.push({ resolve, reject });
        }).then(token => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return defaultApiClient(originalRequest);
        });
    }

    private async refreshToken(
        originalRequest: any,
        refreshTokenFn: () => Promise<string>,
        onRefreshError: () => void
    ): Promise<any> {
        this.isRefreshing = true;
        originalRequest._retry = true;

        try {
            const newToken = await refreshTokenFn();
            this.processQueue(null, newToken);
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return defaultApiClient(originalRequest);
        } catch (error) {
            console.error('refreshTokenError');
            this.processQueue(error as Error, null);
            onRefreshError();
            return Promise.reject(error);
        } finally {
            this.isRefreshing = false;
        }
    }
}